module.exports = __webpack_public_path__ + "static/media/trash.57078c8d.svg";